import dayjs from 'dayjs'
import 'dayjs/locale/ja'
dayjs.locale('ja')
import { EventCategory, EventResponseACF } from '@/types/Event'

export function getEventTags(event: {
  acf: Pick<EventResponseACF, 'event_benefits' | 'event_seminar'>
}): string[] {
  const tags: string[] = []
  const benefits = event.acf.event_benefits
  const seminar = event.acf.event_seminar
  if (Array.isArray(benefits) && benefits.length > 0) {
    tags.push('イベント特典あり')
  }
  if (Array.isArray(seminar) && seminar.length > 0) {
    tags.push('セミナーあり')
  }
  return tags
}

export function getEventCategoryName(
  categories: Pick<EventCategory, 'name'>[]
): string {
  if (categories.length === 0) return ''
  if (categories.some((cat) => cat.name === 'キャリアガイダンス')) {
    return 'キャリアガイダンス'
  }
  return categories[0].name || ''
}

export function getEventDisplayDate(dateStr: string, timeOnly = false) {
  if (timeOnly) return dayjs(dateStr).format('H時mm分')
  return dayjs(dateStr).format('YYYY年M月D日(ddd) H時mm分')
}

export function getEventDisplayTerm(
  term_start: string,
  term_end: string
): string {
  const timeOnly = dayjs(term_start).isSame(term_end, 'day')
  const startDate = getEventDisplayDate(term_start)
  const endDate = getEventDisplayDate(term_end, timeOnly)
  return `${startDate}～${endDate}`
}

export function getEventPlaceName(event: {
  acf: Pick<EventResponseACF, 'event_type' | 'event_place'>
}): string {
  const eventTypeLabel = event.acf.event_type.label || ''
  const eventPlace = event.acf.event_place || {}
  if (eventTypeLabel === 'オンライン') {
    return `${eventPlace.name}`
  }
  if (eventTypeLabel === 'オフライン') {
    return `${eventPlace.name}(${eventPlace.prefecture}${eventPlace.city})`
  }
  return ''
}

function getEventCastTypes(event: {
  acf: Pick<EventResponseACF, 'event_cast_type'>
}) {
  const eventCastTypes = event.acf.event_cast_type || []
  return eventCastTypes.map(
    (type: { value: string; label: string }) => type.label
  )
}

function getEventFilterTypes(event: {
  acf: Pick<EventResponseACF, 'event_filter_type'>
}) {
  const eventFilterTypes = event.acf.event_filter_type || []
  return eventFilterTypes.map(
    (type: { value: string; label: string }) => type.label
  )
}

// TODO: ｀type`は抽象的なので、`keywords`など、具体化したい
export function getEventTypes(event: {
  acf: Pick<
    EventResponseACF,
    'event_type' | 'event_cast_type' | 'event_filter_type'
  >
  event_category: EventCategory[]
}): string[] {
  const categoryName = getEventCategoryName(event.event_category)
  const eventTypeLabel = event.acf.event_type.label // オンライン or オフライン
  const castTypes = getEventCastTypes(event)
  const filterTypes = getEventFilterTypes(event)
  // NOTE: イベントカテゴリのキャリアガイダンス優先
  if (categoryName === 'キャリアガイダンス') {
    return ['キャリアガイダンス', ...castTypes, ...filterTypes]
  }
  return [eventTypeLabel, ...castTypes, ...filterTypes]
}
